import Rails from '@rails/ujs';

export default class AdminsIndex {

    constructor() {
        this.bindEvents();
    }

    bindEvents() {
      $(".teams-select").select2({
        placeholder: "Choix des équipes",
        allowClear: true,
        closeOnSelect: false
      })
      
      $(".teams-select").on('change', (e) => {
        this.updateAdminsTeams(e)
      })

      $(".admin-enabled-toggle").on('change', (e) => {
        this.toggleAdminDisabled(e)
      })
    }

    updateAdminsTeams(element) {
      let teams = $(element.target).val() || []
      let url = $(element.target).data('url')

      let params = new URLSearchParams()
      teams.forEach(teamId => params.append('team_ids[]', teamId))

      Rails.ajax({
        url: url,
        type: 'PUT',
        data: params.toString(),
        success: () => {
          application.successNotification("Affectation effectuée avec succès")
        },
        error: () => {
          application.errorNotification("Erreur lors de l'affectation")
        }
      })
    }

    toggleAdminDisabled(element) {
      let checkbox = $(element.target)
      let url = checkbox.data('url')
      let adminId = checkbox.data('admin-id')
      let isEnabled = checkbox.is(':checked')
      let row = $(`tr[data-admin-id="${adminId}"]`)

      Rails.ajax({
        url: url,
        type: 'PUT',
        data: `is_enabled=${isEnabled}`,
        success: (response) => {
          if (response.success) {
            application.successNotification(response.message)
            if (response.disabled) {
              row.addClass('table-secondary')
              row.find('td:not(:last-child):not(:first-child)').addClass('text-muted')
              row.find('.nav-user img').addClass('opacity-50')
            } else {
              row.removeClass('table-secondary')
              row.find('td').removeClass('text-muted')
              row.find('.nav-user img').removeClass('opacity-50')
            }
          }
        },
        error: (response) => {
          checkbox.prop('checked', !isEnabled)
          let errorMsg = response.error || "Erreur lors de la modification"
          application.errorNotification(errorMsg)
        }
      })
    }

    onDataChanged(data) {
    }

    onDestroy() {
      $(".teams-select").select2('destroy')
      $(".admin-enabled-toggle").off('change')
    }
}